import React from 'react';
import { Box, Button, Grid } from '@mui/material';

import { matchPathname } from '../../Utils';
import { RicBeaconButton, RicBeaconIcon } from './BeaconRegister';
import { BASE_URL, includeQueryParams, investingExperienceUrl, nextStepsURLs } from './Links';


export default function BlueBanner() {
    const params = new URLSearchParams(window.location.search);
    const isInvestingExperience = params.get('investing-experience') === 'true';
    return (
        <Box className='beacon-theme-modern-outlook'>
            <Box
                className='b-container'
                sx={{
                    color: '#FFFFFF',
                    paddingTop: {
                        xs: '16px',
                        md: '56px'
                    },
                    paddingBottom: {
                        xs: '16px',
                        md: '56px'
                    },
                    alignItems: 'center',
                    background: '#061937',
                    inlineSize: 'unset !important'
                }}>
                <Grid container>
                    <Grid item size={{ xs: 12, md: matchPathname(nextStepsURLs).length ? 9 : 12 }}>
                        <Box>
                            {isInvestingExperience &&
                                <RicBeaconButton variant="tertiary" title="Back to Planning Summary" linkHref={investingExperienceUrl}>
                                    <span style={{
                                        display: 'flex',
                                        gap: '8px',
                                        alignItems: 'center',
                                        color: '#80C8FF'
                                    }}>
                                        <RicBeaconIcon name="chevron_left_small" size="m" /> Back to Planning Summary
                                    </span>
                                </RicBeaconButton>
                            }
                            <Box
                                sx={{ color: 'white' }}
                                className='b-typography-serif--headline--600 b-font-weight-bold'
                                id="blue-banner-header"
                            >
                                Retirement Income Calculator
                            </Box>
                            <div
                                className='b-typography-sans-serif--headline--300 b-font-weight-light'
                                id="blue-banner-content"
                            >
                                Are you on track for retirement? Let&apos;s find out.
                            </div>
                        </Box>
                    </Grid>
                    {matchPathname(nextStepsURLs).length ? (
                        <Grid item size={{ xs: 12, md: 3 }} sx={{ display: 'flex' }}>
                            <Box
                                sx={{
                                    sm: { paddingTop: '16px' },
                                    padding: { xs: '32px 0', md: '16px 0' },
                                    width: '100%',
                                }}
                            >
                                <Button
                                    disableRipple
                                    sx={{
                                        color: 'white',
                                        fontSize: '16px',
                                        background: '#061937',
                                        alignSelf: { xs: 'flex-end', md: 'flex-start' },
                                        textTransform: 'capitalize',
                                        boxShadow: 'none',
                                        border: '1px solid white',
                                        width: '100%',
                                        '&:hover': {
                                            backgroundColor: 'white',
                                            color: '#061937',
                                            textDecoration: 'none',
                                            width: '100%'
                                        }
                                    }}
                                    id="restart-calculator-button"
                                    onClick={() => { window.location.replace(includeQueryParams(BASE_URL))}}
                                    variant="contained"
                                >
                                    Restart Calculator
                                </Button>
                            </Box>
                        </Grid>
                    ) : ('')}
                </Grid>
            </Box>
        </Box>
    );
};
